import BvEmptySearchResult from 'volta/components/bv-empty-search-result/index';
import Onboarding from 'volta/components/onboarding/index';
import t from 'ember-intl/helpers/t';
import pageTitle from 'ember-page-title/helpers/page-title';
import RouteTemplate from 'ember-route-template';

export default RouteTemplate<{ Args: { model: unknown; controller: unknown } }>(
  <template>
    {{pageTitle (t 'loginPage.formTitle')}}
    <Onboarding>
      <div class='login-form-wrapper'>
        <BvEmptySearchResult
          @title={{t 'loginPage.error.title'}}
          @description={{t 'loginPage.error.description'}}
        />
      </div>
    </Onboarding>
  </template>
);
